module.exports = __webpack_public_path__ + "cf.svg?8cc39dd42b8cf2a464db10cc412b62e5";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cf.svg
// module id = 1023
// module chunks = 27